import { render, staticRenderFns } from "./messageTemp-list-new.vue?vue&type=template&id=053bc506&scoped=true"
import script from "./messageTemp-list-new.vue?vue&type=script&lang=ts"
export * from "./messageTemp-list-new.vue?vue&type=script&lang=ts"
import style0 from "./messageTemp-list-new.vue?vue&type=style&index=0&id=053bc506&prod&lang=scss&scoped=true"
import style1 from "./messageTemp-list-new.vue?vue&type=style&index=1&id=053bc506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053bc506",
  null
  
)

export default component.exports